import { render, staticRenderFns } from "./RequestForMaterialCard.vue?vue&type=template&id=6996e7e7"
import script from "./RequestForMaterialCard.vue?vue&type=script&lang=js"
export * from "./RequestForMaterialCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports